import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';

export default class MotivoVisitaValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;
        let mv = model;

        if ( !mv.descricao ) {
            refs.descricaoInput.focusedOut = true;
            validated = false;
        }
        if ( !validated ){
            this.showMessage(new Message('alert', 'msg-campos-obrigatorios', true));
        }
        
        return validated;
    }

}